module.exports = __webpack_public_path__ + "img/three-men-hats.62a4a075.jpg";